import { css } from 'aphrodite';
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../components/Breadcrumb';
import { baseStyleSheet } from '../../styles/styles';
import { styleSheet } from './styles';

type BreadcrumbItemType = {
	label: string;
	path?: string;
};

type Props = {
	items: BreadcrumbItemType[];
	banner?: React.ReactNode;
};
export const BreadcrumbBar = ({ items, banner }: Props) => {
	return (
		<div className={css(styleSheet.breadcrumbsBar)}>
			<Breadcrumb>
				<BreadcrumbList>
					{items.map((item, index) => (
						<React.Fragment key={`breadcrumb-item-${item.label}-to-${item.path}-index-${index}`}>
							{index !== 0 && <BreadcrumbSeparator />}
							<BreadcrumbItem key={`breadcrumb-item-${item.label}-to-${item.path}-index-${index}`}>
								{item.path ? (
									<BreadcrumbLink asChild>
										<NavLink to={item.path}>
											<h1 className={css(baseStyleSheet.breadcrumbTitle)}>{item.label}</h1>
										</NavLink>
									</BreadcrumbLink>
								) : (
									<BreadcrumbPage>{item.label}</BreadcrumbPage>
								)}
							</BreadcrumbItem>
						</React.Fragment>
					))}
				</BreadcrumbList>
			</Breadcrumb>

			{banner}
		</div>
	);
};
